import { render, staticRenderFns } from "./BaseAssessmentStatusMetric.vue?vue&type=template&id=43f06ce6&"
import script from "./BaseAssessmentStatusMetric.vue?vue&type=script&lang=js&"
export * from "./BaseAssessmentStatusMetric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports